export const percentageToDecimalString = (percent: string): string => {
  // Convert the percentage to a decimal number
  const decimal = parseFloat(percent) / 100;

  // Convert the decimal number to a string
  const decimalString = decimal.toString();

  return decimalString;
};
